import React, { useContext } from 'react';

import styled from '@emotion/styled';

import useLogComplaint from '../../../../hooks/dashboard/driver-list/useLogComplaint';
import {
  LogComplaintDataType,
  LogComplaintInitialValues,
  LogComplaintSchema,
} from '../../../../models/dashboard/driver-list/log-complaint';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import { FormComponent } from '../../../FormCom/FormComponent';
import { TextAreaInputField } from '../../../FormCom/FormField';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';

interface LogComplaintModalProps {
  data: any;
}

const LogComplaintModal: React.FC<LogComplaintModalProps> = ({ data }) => {
  const modalContext = useContext(ModalContext);
  const { logComplaint, loading } = useLogComplaint();

  const onSubmit = (values: LogComplaintDataType) => {
    logComplaint(values, data?.driverId ?? '', () =>
      modalContext?.setShowModal(false),
    );
  };

  return (
    <ModalContainer label='Log Complaint'>
      <FormComponent
        initialValues={LogComplaintInitialValues}
        schema={LogComplaintSchema}
        onSubmit={onSubmit}
      >
        <BioArea>
          <Img src={data?.profilePicture ?? ''} />
          <NameLabel>{data?.name ?? 'N/A'}</NameLabel>
        </BioArea>
        <TextAreaInputField
          name='verificationIssueLog'
          id='verificationIssueLog'
          type='text'
          label='Log a Complaint'
          placeholder={`Please log your complaint, explaining why this driver's validation should not be rejected.`}
        />

        <ButtonArea>
          <FormSubmitButton
            className='clear fill'
            btnType='button'
            onClick={() => modalContext?.setShowModal(false)}
          >
            Cancel
          </FormSubmitButton>
          <FormSubmitButton loading={loading} className='fill'>
            Submit
          </FormSubmitButton>
        </ButtonArea>
      </FormComponent>
    </ModalContainer>
  );
};

export default LogComplaintModal;

const ButtonArea = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
`;

const BioArea = styled.div`
  border: 1px solid red;
  display: flex;
  gap: 20px;
  align-items: center;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  border-radius: 6px;
`;

const Img = styled.img`
  width: 67px;
  height: 67px;
  border-radius: 8px;
  overflow: hidden;
`;

const NameLabel = styled.span`
  font-weight: 600;
  font-size: 18px;
  line-height: 18px;
`;
